import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IDisableIdentityMigrationInfoToastParams {
}

export class DisableIdentityMigrationInfoToastRequest extends Request<IDisableIdentityMigrationInfoToastParams, IResult> {
  constructor(params: IDisableIdentityMigrationInfoToastParams = {}) {
    super('disableIdentityMigrationInfoToast', params);
  }
}
